module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-modal modal fade noselect",
    attrs: {
      "id": "modalCompteRenduDsnComponent"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "tw-flex tw-w-full tw-items-center"
  }, [_c('div', {
    staticClass: "head d-flex tw-items-center"
  }, [_c('div', {
    staticClass: "label mr-2"
  }, [_vm._v("Nature des retours : ")]), _vm._v(" "), _c('div', {
    staticClass: "inp-input-mini icon mr-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ligneCompteRenduSelectionne),
      expression: "ligneCompteRenduSelectionne"
    }],
    staticClass: "input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ligneCompteRenduSelectionne = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.refreshAllReturns();
        _vm.refreshAnomalies();
      }]
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": _vm.ligneCompteRenduTous
    }
  }, [_vm._v(" Tous les retours")]), _vm._v(" "), _vm._l((_vm.compteRendu.ListeLignesCompteRenduDto), function(ligneCompteRendu) {
    return _c('option', {
      domProps: {
        "value": ligneCompteRendu
      }
    }, [_vm._v(" " + _vm._s(ligneCompteRendu.Nature) + " " + _vm._s(ligneCompteRendu.NatureLibelle))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-items-center tw-gap-[15px]"
  }, [(_vm.ligneCompteRenduSelectionne && _vm.anomaliesList) ? _c('div', {
    staticClass: "inp-input-mini icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAnomalieType),
      expression: "selectedAnomalieType"
    }],
    staticClass: "input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAnomalieType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.refreshAnomalies]
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": _vm.undefinedChoice
    }
  }, [_vm._v(" Toutes les anomalies")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.valueAutres
    }
  }, [_vm._v(" Autre")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.valueSalarie
    }
  }, [_vm._v(" Salarié")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.valueIdentifiant
    }
  }, [_vm._v(" Identifiant")])]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })]) : _vm._e(), _vm._v(" "), (_vm.selectedAnomalieType === _vm.valueSalarie) ? _c('div', {
    staticClass: "inp-input-mini icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSalarie),
      expression: "selectedSalarie"
    }],
    staticClass: "input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSalarie = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.refreshAnomalies]
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": _vm.undefinedChoice
    }
  }, [_vm._v(" Tout les salariés")]), _vm._v(" "), _vm._l((_vm.salarieList), function(item) {
    return _c('option', [_vm._v(" " + _vm._s(item))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })]) : _vm._e(), _vm._v(" "), (_vm.selectedAnomalieType === _vm.valueIdentifiant) ? _c('div', {
    staticClass: "inp-input-mini icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedIdentifiant),
      expression: "selectedIdentifiant"
    }],
    staticClass: "input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedIdentifiant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.refreshAnomalies]
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": _vm.undefinedChoice
    }
  }, [_vm._v(" Tout les identifiants")]), _vm._v(" "), _vm._l((_vm.identifiantList), function(item) {
    return _c('option', [_vm._v(" " + _vm._s(item))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "body-table"
  }, [_c('table', {
    staticClass: "generic-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._m(2), _vm._v(" "), _vm._l((_vm.filteredList), function(item) {
    return _c('tr', [_c('th', {
      staticClass: "cln-nature"
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-center",
      attrs: {
        "title": item.Nature
      }
    }, [_vm._v(_vm._s(item.Nature))])]), _vm._v(" "), _c('th', {
      staticClass: "cln-libelle"
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-start tw-text-center",
      attrs: {
        "title": item.NatureLibelle
      }
    }, [_vm._v(_vm._s(item.NatureLibelle))])]), _vm._v(" "), _c('th', {
      staticClass: "cln-statut"
    }, [_c('span', {
      staticClass: "tw-w-full tw-overflow-hidden tw-text-ellipsis tw-text-center",
      attrs: {
        "title": item.Statut
      }
    }, [_vm._v(_vm._s(item.Statut))])]), _vm._v(" "), _c('th', {
      staticClass: "cln-action"
    }, [(item.CodeDocumentGed) ? _c('button', {
      staticClass: "inp-button blue",
      attrs: {
        "type": "button",
        "title": "Télécharger"
      },
      on: {
        "click": function($event) {
          _vm.telecharger(item)
        }
      }
    }, [_c('span', {
      staticClass: "fas fa-file-download"
    }), _vm._v(" "), _c('div', {
      staticClass: "text ml-2"
    }, [_vm._v("Télécharger")])]) : _vm._e(), _vm._v(" "), (_vm.isVisibleMajTauxPas(item)) ? _c('button', {
      staticClass: "inp-button green",
      attrs: {
        "type": "button",
        "title": "Mettre à jour le taux PAS",
        "disabled": _vm.compteRendu.EstTauxPasSalarieActualise
      },
      on: {
        "click": function($event) {
          _vm.mettreAJourTauxPas()
        }
      }
    }, [_c('span', {
      staticClass: "icon fas fa-pencil-alt fa-fw mr-1"
    }), _vm._v(" "), _c('div', {
      staticClass: "text ml-2"
    }, [_vm._v("Mettre à jour le taux PAS")])]) : _vm._e()])])
  })], 2)])]), _vm._v(" "), (_vm.ligneCompteRenduSelectionne) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "margin": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "15%"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "card-salarie-header float-left m-0 tw-underline"
  }, [_vm._v("Résumé")]), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Nature) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "50%"
    }
  }, [_vm._v("Nature")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Nature))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Statut) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "50%"
    }
  }, [_vm._v("Statut")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Statut))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identifiant) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "50%"
    }
  }, [_vm._v("Identifiant")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Identifiant))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Profil) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "50%"
    }
  }, [_vm._v("Profil")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Profil))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Type) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "50%"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Type))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Message) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "50%"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Message))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Version) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "50%"
    }
  }, [_vm._v("Version")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Version))])]) : _vm._e()])]), _vm._v(" "), (_vm.ligneCompteRenduSelectionne && _vm.ligneCompteRenduSelectionne.Bilan) ? _c('div', {
    staticStyle: {
      "width": "20%"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "card-salarie-header float-left m-0 tw-underline"
  }, [_vm._v("Bilan")]), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Bilan.NombreSalaries) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "65%"
    }
  }, [_vm._v("Nb salariés")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Bilan.NombreSalaries))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Bilan.NombreDeclarations) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "65%"
    }
  }, [_vm._v("Nb déclarations")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Bilan.NombreDeclarations))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Bilan.NombreNonSalaries) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "65%"
    }
  }, [_vm._v("Nb non salariés")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Bilan.NombreNonSalaries))])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Bilan.Etat) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "65%"
    }
  }, [_vm._v("État")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.ligneCompteRenduSelectionne.Bilan.Etat))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.ligneCompteRenduSelectionne.Bilan.Compteurs), function(item) {
    return (_vm.ligneCompteRenduSelectionne.Bilan.Compteurs) ? _c('div', {
      staticStyle: {
        "width": "100%",
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "width": "65%"
      }
    }, [_vm._v(_vm._s(item.Categorie))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "35%"
      }
    }, [_vm._v(_vm._s(item.Nombre))])]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne && _vm.ligneCompteRenduSelectionne.Identification) ? _c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "card-salarie-header float-left m-0 tw-underline"
  }, [_vm._v("Identification")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "50%",
      "margin": "0"
    }
  }, [(_vm.ligneCompteRenduSelectionne.Identification.DeclarantNom) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "35%"
    }
  }, [_vm._v("Nom déclarant")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                                                " + _vm._s(_vm.ligneCompteRenduSelectionne.Identification.DeclarantNom) + "\n                                            ")])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.DeclarantPrenom) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "35%"
    }
  }, [_vm._v("Prénom déclarant")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                                                " + _vm._s(_vm.ligneCompteRenduSelectionne.Identification.DeclarantPrenom) + "\n                                            ")])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.DeclarantSiret) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "35%"
    }
  }, [_vm._v("Siret déclarant")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                                                " + _vm._s(_vm.ligneCompteRenduSelectionne.Identification.DeclarantSiret) + "\n                                            ")])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.Conformite) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "35%"
    }
  }, [_vm._v("Conformite")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                                                " + _vm._s(_vm.ligneCompteRenduSelectionne.Identification.Conformite) + "\n                                            ")])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.SiretEmetteur) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "35%"
    }
  }, [_vm._v("Siret Emetteur")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                                                " + _vm._s(_vm.ligneCompteRenduSelectionne.Identification.SiretEmetteur) + "\n                                            ")])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.Type) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "35%"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                                                " + _vm._s(_vm.ligneCompteRenduSelectionne.Identification.Type) + "\n                                            ")])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.PointDeDepot) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "35%"
    }
  }, [_vm._v("Dépôt")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                                                " + _vm._s(_vm.ligneCompteRenduSelectionne.Identification.PointDeDepot) + "\n                                            ")])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.TypeEnvoi) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "35%"
    }
  }, [_vm._v("TypeEnvoi")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                                                " + _vm._s(_vm.ligneCompteRenduSelectionne.Identification.TypeEnvoi) + "\n                                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "50%",
      "margin": "0"
    }
  }, [(_vm.ligneCompteRenduSelectionne.Identification.Identifiant) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "35%"
    }
  }, [_vm._v("Identifiant")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                                                " + _vm._s(_vm.ligneCompteRenduSelectionne.Identification.Identifiant) + "\n                                            ")])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.IdFlux) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "35%"
    }
  }, [_vm._v("Flux")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "65%"
    },
    attrs: {
      "title": _vm.ligneCompteRenduSelectionne.Identification.IdFlux
    }
  }, [_vm._v("\n                                                " + _vm._s(_vm.ligneCompteRenduSelectionne.Identification.IdFlux) + "\n                                            ")])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.VersionNorme) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "35%"
    }
  }, [_vm._v("Norme")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                                                " + _vm._s(_vm.ligneCompteRenduSelectionne.Identification.VersionNorme) + "\n                                            ")])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.NomLogiciel) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "35%"
    }
  }, [_vm._v("Logiciel")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                                                " + _vm._s(_vm.ligneCompteRenduSelectionne.Identification.NomLogiciel) + "\n                                            ")])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.EditeurLogiciel) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "35%"
    }
  }, [_vm._v("Éditeur")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                                                " + _vm._s(_vm.ligneCompteRenduSelectionne.Identification.EditeurLogiciel) + "\n                                            ")])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne.Identification.VersionLogiciel) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "width": "35%"
    }
  }, [_vm._v("Version")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_vm._v("\n                                                " + _vm._s(_vm.ligneCompteRenduSelectionne.Identification.VersionLogiciel) + "\n                                            ")])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.ligneCompteRenduSelectionne && _vm.ligneCompteRenduSelectionne.ListeEffectifs) ? _c('div', {
    staticStyle: {
      "width": "55%"
    }
  }, [_c('div', {
    staticClass: "card-salarie-header"
  }, [_vm._v("Liste des effectifs du " + _vm._s(_vm._f("moment")(_vm.ligneCompteRenduSelectionne.ListeEffectifs[0].DateDebutPeriode, "DD/MM/YY")) + " au " + _vm._s(_vm._f("moment")(_vm.ligneCompteRenduSelectionne.ListeEffectifs[0].DateFinPeriode, "DD/MM/YY")))]), _vm._v(" "), _vm._l((_vm.ligneCompteRenduSelectionne.ListeEffectifs), function(item) {
    return _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "width": "85%"
      }
    }, [_vm._v(_vm._s(_vm.getCodeEffectif(item.CodeEffectif)) + " " + _vm._s(item.Libelle))]), _vm._v(" "), _c('div', {
      staticClass: "text-right",
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.Valeur))])])
  })], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.anomaliesList) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "tw-flex tw-flex-col tw-gap-[10px]"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "tbody tw-flex tw-flex-col tw-gap-[10px]"
  }, _vm._l((_vm.anomaliesList), function(item) {
    return _c('div', {
      staticClass: "trow anomalie",
      staticStyle: {
        "font-size": "1em",
        "white-space": "unset"
      }
    }, [(item.Description) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "100%",
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "width": "25%"
      }
    }, [_vm._v("Code")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "75%"
      }
    }, [_vm._v(_vm._s(item.Description.Code))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "width": "25%"
      }
    }, [_vm._v("Categorie")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "75%"
      }
    }, [_vm._v(_vm._s(item.Description.Categorie))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "width": "25%"
      }
    }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "75%"
      }
    }, [_vm._v(_vm._s(item.Description.Message))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "width": "25%"
      }
    }, [_vm._v("Numero Ligne")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "75%"
      }
    }, [_vm._v(_vm._s(item.Description.NumeroLigne))])])]) : _vm._e(), _vm._v(" "), (item.Valeur) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "100%",
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "width": "25%"
      }
    }, [_vm._v("Identifiant")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "75%"
      }
    }, [_vm._v(_vm._s(item.Valeur.Identifiant))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "width": "25%"
      }
    }, [_vm._v("Libelle")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "75%"
      }
    }, [_vm._v(_vm._s(item.Valeur.Libelle))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "display": "flex"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold",
        "width": "25%"
      }
    }, [_vm._v("Valeur")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "75%"
      }
    }, [_vm._v(_vm._s(item.Valeur.Valeur))])])]) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.isLoading !== 0) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    attrs: {
      "id": "Centrerloader"
    }
  }, [_c('loader')], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "area-action"
  }, [_c('button', {
    staticClass: "inp-button-modal cancel ml-1 mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.annuler()
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Fermer")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Compte rendu de la DSN")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "title": "Fermer"
    }
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "tr"
  }, [_c('th', {
    staticClass: "th cln-nature",
    attrs: {
      "title": "Nature"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Nature")])]), _vm._v(" "), _c('th', {
    staticClass: "th cln-libelle",
    attrs: {
      "title": "Libellé"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Libellé")])]), _vm._v(" "), _c('th', {
    staticClass: "th cln-statut",
    attrs: {
      "title": "Statut"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Statut")])]), _vm._v(" "), _c('th', {
    staticClass: "th cln-action",
    attrs: {
      "title": "Action"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Action")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "line"
  }, [_c('th', {
    staticClass: "section cln-nature"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-libelle"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-statut"
  }), _vm._v(" "), _c('th', {
    staticClass: "section cln-action"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thead"
  }, [_c('span', {
    staticClass: "tw-underline",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("Anomalies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2b42d34"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsn/modalCompteRenduDsn/modalCompteRenduDsn.vue.html
// module id = uwY5
// module chunks = 2